import useMatchBreakpoint from './use-match-breakpoint';
import { breakpoints } from '../constants';

const useMatchMDBreakpoint = () => {
  const matches = useMatchBreakpoint(breakpoints.md);
  return matches;
};

export default useMatchMDBreakpoint;
